import type { DataTableRow } from "@client-shared";
import type { LabelPrintBatch } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { setBatchesTableCellTestId } from "../batches-table.utils";

export const BatchNotesCellMarkup = (props: CellContext<DataTableRow<LabelPrintBatch>, unknown>) => {
  const notes = props.row.original.batchNotes;

  if (!notes) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }

  return (
    <span
      className="block max-w-[18rem] truncate text-sm text-muted-foreground"
      data-testid={setBatchesTableCellTestId("batchNotes", props.row.index)}
      title={notes}
    >
      {notes}
    </span>
  );
};
